'use strict';
var $ = require('jquery');

const logger = require('../utils/logger.js');
const localStorageUtils = require('../utils/localStorageUtils.js');
const vendorConsents = require('../utils/vendor-consents.js');

const CONSENT_STORAGE_KEY = 'consentData'; // TODO Move this into localStorageUtils.js

function createScriptElement() {
    var script = document.createElement('script');
	script.setAttribute('data-wid', 'auto');
    script.type = 'text/javascript';
    script.src = 'https://content.viralize.tv/display/?zid=AAFkvAwTAGs2GGRx';
    return script;
}

function insertScriptAfterElement(element, script) {
    $(element).after(script);
}

function injectShowHeroesAds(className) {
	var firstParagraph = $.findByBem(className).children('p').first();
	if (firstParagraph.length > 0) {
		var script = createScriptElement();
		insertScriptAfterElement(firstParagraph, script);
	}
}

module.exports = {
	init: (block, element='', modifier='') => {
		const storedConsent = localStorageUtils.getItem(CONSENT_STORAGE_KEY);
		if (!storedConsent) {
			logger.warning('Failed to initialise inject show heroes ads script: No consent data');
			return;
		}

		const hasBauerConsent = storedConsent.consentedVendors.includes(vendorConsents.vendorIds.bauerMediaGroup);
		if (hasBauerConsent) {
			injectShowHeroesAds(block, element, modifier);
		} else {
			logger.info('Did not initialise inject show heroes ads script on completed user action: Insufficient consent');
		}
	}
};
